import React, { Component, Fragment } from 'react'
import { Hero } from '../../components/Layout'
import { TableContent, ModalCreate, ModalEdit } from './components'
import { Input, Icon, Button } from 'antd'
import { api } from '../../services'

export default class extends Component {
  state = {
    search: '',
    modal: {
      create: false,
      edit: false
    },
    selectedDivision: null,
    organizations: []
  }

  componentDidMount () {
    this.getDivisions()
    this.getOrganizations()
  }

  getDivisions = () => {
    const { getDivisions } = this.props
    if (getDivisions) {
      getDivisions()
    }
  }

  getOrganizations = () => {
    const { getOrganizations } = this.props
    if (getOrganizations) {
      getOrganizations()
    }
  }

  openModal = (type) => {
    this.setState(state => ({
      modal: {
        ...state.modal,
        [type]: true
      }
    }))
  }

  closeModal = (type) => {
    this.setState(state => ({
      modal: {
        ...state.modal,
        [type]: false
      }
    }))
  }

  selectDivision = (data) => {
    this.setState({
      selectedDivision: data
    })
    this.openModal('edit')
  }

  onCreateButton = () => {
    api.organization.getOrganizations().then((response) => {
      this.setState({
        organizations: response.data.result
      })
    })
  }

  render () {
    const { division, organization } = this.props
    const { search, modal, selectedDivision } = this.state

    return (
      <Fragment>
        <div className='app__content'>
          <div className='content__hero'>
            <Hero heading='Divisions' />
          </div>
          <div className='content__page'>
            <div className='container'>
              <div className='page'>
                <div className='page-content page__content'>
                  <div className='page-content-head page-content__head'>
                    <div className='page-content-head__controls' style={{ width: '100%' }}>
                      <div className='page-content-head__control'>
                        <Button type='indigo' onClick={() => this.openModal('create')}>Create Division</Button>
                      </div>
                      <div className='page-content-head__control page-content-head__control_last' style={{ marginLeft: 'auto' }}>
                        <Input
                          value={search}
                          prefix={<Icon type='search' style={{ color: 'rgba(0,0,0,.25)' }} />}
                          onChange={(e) => this.setState({ search: e.target.value })}
                          placeholder='Search'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='page-content__table'>
                    <TableContent
                      loading={division.isFetching}
                      list={division.list.filter(i => i.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)}
                      callback={this.getDivisions}
                      selectDivision={this.selectDivision}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalCreate organization={organization} callback={this.getDivisions} visible={modal.create} onCancel={() => this.closeModal('create')} />
        <ModalEdit organization={organization} callback={this.getDivisions} visible={modal.edit} data={selectedDivision} onCancel={() => this.closeModal('edit')} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Divisions/Divisions.jsx